import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { PaymentModel, PaymentCheckModel, SubscriberModel } from '../models/superbit-api-models';
import { SubscribersModel } from '../models/SubscribersModel';
import '../assets/css/_simple-popup.css'
import '../assets/css/_new-lead-popup.css'
//import './_VehicleDetails.css'
import '../vehicles/_VehicleDetails.css'
import PaymentItem from "./_PaymentItem"
import "react-datepicker/dist/react-datepicker.css";
import { faPenToSquare } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
type Props = {
    paymentsList: PaymentModel[] | undefined;
    RiderId: string | undefined;
    EditPayment: Function;
    setIsAddPayment: Function;
    
};



const PaymentsList = (props: Props) => {
    const [Payments, setPayments] = useState<PaymentModel[] | undefined>(props.paymentsList ? props.paymentsList : []);

    // useEffect(() => {
    //     // init();
    // }, [props])

//     const init = async () => {
//         var data = await new SubscribersModel().riderGetPayments(props.RiderId, undefined);
// //
//         setPayments(data);
//     }

    const nextInPayment = () => {
        props.setIsAddPayment(true);
        props.EditPayment("");
    }


    return (
        <div >
                <div className='payment-tab'>
                        <div className="tab-content-title">
                            תשלומים קודמים



                        </div>
                        <div className="parameter-row">
                            <div className="parameter-item">
                                <div className="field">
                                    <div className="title">
                                        מהות התשלום
                                    </div>

                                </div>
                            </div>
                            <div className={`parameter-item`}>
                                <div className="field">
                                    <div className="title">
                                        סכום
                                    </div>

                                </div>
                            </div>
                            <div className={`parameter-item `}>
                                <div className="field">
                                    <div className="title">
                                        אופן התשלום
                                    </div>

                                </div>
                            </div>
                            <div className="parameter-item">
                                <div className="field">
                                    <div className="title">
                                        תאריך
                                    </div>

                                </div>
                            </div>
                            <div className="parameter-item">
                                <div className="field">
                                    <div className="title">
                                        סטטוס
                                    </div>

                                </div>
                            </div>
                            <div className="parameter-item">
                                <div className="field">
                                    <div className="title">
                                    {Payments && !Payments.some(payment => payment.paymentStatus === 0) ?
                                    <button className='btn-add-payment' onClick={nextInPayment}>הוספת תשלום +</button>
                                    // <div onClick={(e: any) => props.EditPayment("")}><FontAwesomeIcon icon={faPenToSquare} /></div>
                                    : ""}
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>


            {Payments ? Payments.map((item: PaymentModel, index: number) => (
                <PaymentItem Payment={item} EditPayment={props.EditPayment} />
            )) : ""}
        </div >

    );
};


export default PaymentsList;
